import { lazy } from 'react'
const AdvancedSettings = lazy(() => import('../pages/AdvancedSettings'));
// import Settings from '../pages/Settings';
// import Alerts from '../pages/Alerts';
// import Cameras from '../pages/Cameras';
// import Rules from '../pages/Rules';
// import Zones from '../pages/Zones';
// import Sites from '../pages/Sites';
// import Users from '../pages/Users';
// import SignIn from '../pages/SignIn';
// import PasswordRecovery from '../pages/PasswordRecovery';
// import NotFound from '../pages/NotFound';
// import AccessDenied from '../pages/AccessDenied';
// import  SignUpNew  from '../pages/SignUp';
// import Dashboard from '../pages/Dashboard';


// use lazy for better code splitting, a.k.a. load faster
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Alerts = lazy(() => import("../pages/Alerts"));
const Cameras = lazy(() => import("../pages/Cameras"));
const Rules = lazy(() => import("../pages/Rules"));
const Zones = lazy(() => import("../pages/Zones"));
const Users = lazy(() => import("../pages/Users"));
const Counts = lazy(() => import("../pages/Counts"));
const SignUpNew = lazy(() => import("../pages/SignUp"));
const SignIn = lazy(() => import("../pages/SignIn"));
const AccessDenied = lazy(() => import("../pages/AccessDenied"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Settings = lazy(() => import("../pages/Settings"));
const RuleSettings = lazy(() => import("../pages/RuleSettings"));
const PasswordRecovery = lazy(() => import("../pages/PasswordRecovery"));
const Sites = lazy(() => import("../pages/Sites"));
const ServeurError = lazy(() => import("../pages/ServeurError"));
const RuleUpdate = lazy(() => import("../pages/RuleUpdate"));
const RuleVerify = lazy(() => import("../pages/RuleVerify"));
const SafetyTasks = lazy(() => import("../pages/SafetyTasks"));
const Status = lazy(() => import("../pages/Status"));
const MS2ControlCenter = lazy(() => import("../pages/MS2"));
// const AiAssistant =lazy(()=>import("../pages/AiAssistant"))



/**
 * ⚠ These are internal routes!
 * They will be rendered inside the app, using the default `containers/Layout`.
 * If you want to add a route to, let's say, a landing page, you should add
 * it to the `App`'s router, exactly like `Login`, `CreateAccount` and other pages
 * are routed.
 *
 * If you're looking for the links rendered in the SidebarContent, go to
 * `routes/sidebar.js`
 */
export const privateRoutes = [
    {
        path: "/",
        element: <Dashboard />,
    },
    {
        path: "/model-definitions",
        element: <AdvancedSettings />,
    },
    {
        path: "/settings",
        element: <Settings />,
    },
    {
        path: "/alerts",
        element: <Alerts />,
    },
    {
        path: "/cameras",
        element: <Cameras />,
    },
    {
        path: "/rules",
        element: <Rules />,
    },
    {
        path: "/rule/settings",
        element: <RuleSettings />,
    },
    {
        path: "/rule/settings/:id",
        element: <RuleSettings />,
    },
    {
        path: "/rule/update/:id",
        element: <RuleUpdate />,
    },
    {
        path: "/zones",
        element: <Zones />,
    },
    {
        path: "/sites",
        element: <Sites />,
    },
    {
        path: "/counts",
        element: <Counts />,
    },
    {
        path: "/safety-tasks",
        element: <SafetyTasks />,
    },
    {
        path: "/users",
        element: <Users />,
    }
    // },{
    //     path:"/aiassistant",
    //     element:<AiAssistant/>
    // }

];
const routes = [
    {
        path: "/signup",
        element: <SignUpNew />,
    },
    {
        path: "/signin",
        element: <SignIn />,
    },
    {
        path: "/passwordRecovery",
        element: <PasswordRecovery />,
    },
    {
        path: "/status",
        element: <Status />,
    },
    {
        // Bare page with its own login (same credentials as Watch).
        path: "/ms2",
        element: <MS2ControlCenter />,
    },
    {
        // Deliberately kept out of `privateRoutes`: this page renders bare,
        // without the app's Layout/sidebar chrome, and is meant to be opened
        // in its own tab from the rule editor rather than navigated to
        // in-place. It still calls authenticated API endpoints — the token
        // in localStorage is picked up by the normal axios interceptor
        // regardless of which route tree rendered the page.
        path: "/rule/verify/:id",
        element: <RuleVerify />,
    },
    {
        path: "*",
        element: <NotFound />,
    },
    {
        path: "/404",
        element: <NotFound />,
    },
    {
        path: "/500",
        element: <NotFound />,
    },
    {
        path: "/serveurError",
        element: <ServeurError />,
    },
    {
        path: "/access-denied",
        element: <AccessDenied />,
    },

]

export default routes
